import type { RecommendedItem } from './RecommendedList';

export const RECOMMENDED_SLOT_COUNT = 4;
export const UPLIFT_RECOMMENDED_SLOT_COUNT = 2;

export type RecommendedSources = {
	allAgents?: readonly RecommendedItem[];
	favouriteAgents?: readonly RecommendedItem[];
	ootbAgents: readonly RecommendedItem[];
	recentAgents: readonly RecommendedItem[];
	templates: readonly RecommendedItem[];
	verifiedAgents: readonly RecommendedItem[];
};

const FILL_ORDER: readonly { limit: number; source: keyof RecommendedSources }[] = [
	{ limit: 3, source: 'ootbAgents' },
	{ limit: 1, source: 'recentAgents' },
	{ limit: 1, source: 'verifiedAgents' },
	{ limit: 1, source: 'templates' },
	{ limit: 1, source: 'favouriteAgents' },
	{ limit: 1, source: 'allAgents' },
];

export const buildRecommendedItems = (
	sources: RecommendedSources,
	slotCount: number = RECOMMENDED_SLOT_COUNT,
): RecommendedItem[] => {
	// Map order is preserved: see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map
	const items = new Map<string, RecommendedItem>();

	for (const { limit, source } of FILL_ORDER) {
		if (items.size >= slotCount) {
			break;
		}

		for (const item of (sources[source] ?? []).filter(({ id }) => !items.has(id)).slice(0, limit)) {
			items.set(item.id, item);
		}
	}

	return [...items.values()].slice(0, slotCount);
};
